module.exports = __webpack_public_path__ + "static/media/scoutr.810505c3.webp";